<template>
  <div>
    <v-card>
      <v-container grid-list-lg>
        <v-layout class="ma-2" align-center="align-center" justify-center row>
          <div class="text-center">
            <h1 class="display-3 font-weight-bold">Time Clock</h1>
            <h1 class="headline">Payroll fraud costs businesses over</h1>
            <div class="text-center mt-3 font-weight-medium">
              <div>
                <span class="display-2 font-weight-black red--text">$9 MILLION </span>
                <span class="font-weight-medium">a year.</span>
              </div>
              <div>Keeping track of your employees hours is essential for every business.</div>
              <div>One “mistake” can cost you at least 3 months of our service.</div>
              <div>
                Stay on top of your employees by implementing a proper clock in and clock out
                procedure.
              </div>
              <div>
                For just <span class="red--text">{{ price | currency }} a month </span>
                <span>you can get a complete report for </span>
                <span class="red--text">all your employees </span>
                <span>vs. other companies that charge </span>
                <span class="red--text">$10 a month per employee. </span>
              </div>
            </div>
          </div>
        </v-layout>
        <div class="text-center">
          <div class="mt-5">
            <img src="../../../../assets/upSale/timeclock.png" width="250px" />
          </div>
          <v-layout
            class="mt-5"
            wrap
            align-center="align-center"
            justify-center
            row
            fill-height="fill-height"
          >
            <v-btn color="blue darken-1" large text @click="removeDeal">{{
              $t("buttons.noThanks")
            }}</v-btn>
            <v-btn color="blue darken-1" large dark="dark" @click="save">{{
              $t("buttons.addFeature")
            }}</v-btn>
          </v-layout>
        </div>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      price: 5,
      name: "Time Clock"
    };
  },
  methods: {
    ...mapActions("location", ["feature", "removeDeal"]),
    save() {
      this.feature({
        id: 11,
        feature: this.name,
        price: this.price
      });
    }
  }
};
</script>

<style scoped></style>
